import styled from 'styled-components';

type BadgeProps = {
  backgroundColor: string;
};

const Badge = styled.div<BadgeProps>`
  padding: 2px 8px;
  border-radius: 12px;
  background-color: ${(p) => p.backgroundColor + 'a3'}; //64% transparency
  cursor: pointer;
`;

export default Badge;
